import React, { useState } from "react";
import css from "../../style/onbording.module.css";
import { useParams, useHistory } from "react-router";
import { postDocumentsMobile } from "../../store/actions/onboardingActions";
import { toast } from "react-toastify";
import ErrorComponent from "../../components/ErrorComponent";

const ProofOfWorkEligibility = () => {
  const history = useHistory();
  const { id, type } = useParams();

  const [error, setError] = useState("");
  const [Profile, setProfile] = useState();
  const [ProfileImg, setProfileImg] = useState();
  const [takePhoto, setTakePhoto] = useState(false);

  const handleAddImage = (e) => {
    if (e.target.files?.length) {
      setProfile(e.target.files[0]);
      setProfileImg(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleSubmitForm = () => {
    if (Profile) {
      const formData = new FormData();
      formData.append("workEligibilityProFile", Profile);
      postDocumentsMobile(id, type, formData, setError, history);
    } else {
      toast.error("Please upload your Proof of work eligibility.");
    }
  };
  return (
    <div className={css?.mD}>
      {takePhoto ? (
        <>
          <label htmlFor="profile-photo">
            <div className={css?.dlUploadMd}>
              <div className={css?.l2Heading}>Click below to take photo</div>
              <div className={css?.dlUploadImgBG}>
                <img
                  src={ProfileImg ?? "/images/upload.png"}
                  className={ProfileImg ? css?.UploadImg : css?.dlUploadImg}
                />
              </div>
            </div>
          </label>
          <input
            id="profile-photo"
            name="workEligibilityProFile"
            type="file"
            accept="image/*"
            capture="camera"
            onChange={handleAddImage}
            style={{ display: "none" }}
          />
          <ErrorComponent error={error} />
          <div className={css?.submitButton} onClick={handleSubmitForm}>
            Confirm
          </div>
        </>
      ) : (
        <>
          <div className={css?.mHeading}>
            Take a photo of your Proof of Work Eligibility
          </div>
          <div className={css?.mtext}>
            Please upload a current (non-expired) document from the list below
            to verify that you can legally work as an independent contractor in
            Canada:
            <br /> Passport, Residency card, Birth certificate, Citizenship card
            and/or Work permit.
          </div>
          <div className={css?.imageDiv}>
            <img
              src="/images/workEligibilityProFile.png"
              className={css?.weImage}
            />
          </div>
          <div className={css?.submitButton} onClick={() => setTakePhoto(true)}>
            Take Photo
          </div>
        </>
      )}
    </div>
  );
};

export default ProofOfWorkEligibility;
